export const isOfType = <T>(obj: any, key: keyof T): obj is T => {
  if (!obj) {
    return obj;
  }

  return (obj as T)[key] !== undefined;
};
